<!-- <div class="col-12 no-pd" *ngIf="isRejected">
    <app-rejected-mortgage [listRejectReasons]="listRejectReasons" ></app-rejected-mortgage>
</div> -->

<h2 class="sr-only">{{ 'dashboard_available_options' | translate }}</h2>

<div class="row d-flex dashboard">
  <article class="col-sm-6 col-12">
    <app-your-request-section [status]="status" [isRejected]="isRejected"></app-your-request-section>
  </article>
  <article class="col-sm-6 col-12">
    <app-documentation-section [status]="status" [isRejected]="isRejected"></app-documentation-section>
  </article>
</div>
<div class="row d-flex">
  <article class="col-sm-6 col-12">
    <app-appraisal-section [status]="status" [isRejected]="isRejected"></app-appraisal-section>
  </article>
  <article class="col-sm-6 col-12">
    <app-signature-section [status]="status" [isRejected]="isRejected"></app-signature-section>
  </article>
</div>
<!-- <button (click)="authService.setStatus(status + 1)">sumar</button> -->
<!-- <button (click)="authService.setStatus(status - 1)">restar</button> -->
